__turbopack_context__.v({
  "component": "_jO18q_component",
  "container": "_jO18q_container",
});
